import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { legalApi } from '../api/legal';
import { QUERY_KEYS } from '../utils/constants';

const LEGAL_STATUS_KEY = 'legalStatus';
const LEGAL_DOCUMENTS_KEY = 'legalDocuments';
const LEGAL_AGREEMENTS_KEY = 'legalAgreements';

export function useLegalStatus() {
  return useQuery({
    queryKey: [LEGAL_STATUS_KEY],
    queryFn: legalApi.getStatus,
    staleTime: 30 * 1000,
  });
}

export function useLegalDocuments(language = 'en') {
  return useQuery({
    queryKey: [LEGAL_DOCUMENTS_KEY, language],
    queryFn: () => legalApi.getDocuments(language),
    staleTime: 5 * 60 * 1000,
  });
}

export function useSubmitAgreement() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: legalApi.submitAgreement,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [LEGAL_STATUS_KEY] });
      queryClient.invalidateQueries({ queryKey: [LEGAL_AGREEMENTS_KEY] });
    },
  });
}

export function useMyLegalAgreements() {
  return useQuery({
    queryKey: [LEGAL_AGREEMENTS_KEY],
    queryFn: legalApi.getAgreements,
    staleTime: 60 * 1000,
  });
}
